import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    tooltip: null
  },
  setup(__props: any) {



const target = ref<HTMLDivElement>()
const visible = ref(false)
const position = ref({ x: 0, y: 0})

function onMouseEnter() {
    if (target.value) {
        visible.value = true
        const rect = target.value.getBoundingClientRect()
        position.value = {
            x: rect.left + (rect.width / 2),
            y: rect.top + window.scrollY
        }
    }
}

function onMouseLeave() {
    visible.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({ left: position.value.x + 'px', top: position.value.y + 'px' }),
            class: _normalizeClass(_ctx.$style.tooltip)
          }, [
            (!__props.tooltip)
              ? _renderSlot(_ctx.$slots, "tooltip", { key: 0 })
              : _createCommentVNode("", true),
            (__props.tooltip)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: __props.tooltip.replaceAll("\n", "<br />")
                }, null, 8, _hoisted_1))
              : _createCommentVNode("", true)
          ], 6))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", {
      ref_key: "target",
      ref: target,
      onMouseenter: onMouseEnter,
      onMouseleave: onMouseLeave,
      class: _normalizeClass(_ctx.$style.container)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 34)
  ], 64))
}
}

})